import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { updateImportSummarySmallcase } from '../../../api';
import AppContext from '../../context';

const ImportSummary = (props) => {
  const context = useContext(AppContext);
  const { pfId } = props;

  const formatTimestamp = (ts) => {
    if (ts) {
      return moment(ts).format('DD MMM, hh:mm A');
    }
  };

  return (
    <div className={`import-summary mt-4 ${props.show ? '' : 'd-none'}`}>
      <h5 className="title">Import Summary</h5>
      <p className="last-imported">
        Last updated: {formatTimestamp(props.summary.timestamp)}
      </p>
      <section className="content">
        <div>
          <div className="count">
            {props.counts.valid.count}
            {props.counts.valid.synced_count ? (
              <div className="synced-count">
                <span>+ {props.counts.valid.synced_count}</span>
                <span>NEW</span>
              </div>
            ) : null}
          </div>
          <div className="info">
            Symbols Imported <br /> Successfully
          </div>
        </div>
        {props.counts.unrecognised.count ? (
          <div>
            <div className="count invalid">
              {props.counts.unrecognised.count}
              {props.counts.unrecognised.synced_count ? (
                <div className="synced-count">
                  <span>+ {props.counts.unrecognised.synced_count}</span>
                  <span>NEW</span>
                </div>
              ) : null}
            </div>
            <div className="info">
              Unrecognised <br /> Symbols
            </div>
            <button
              type="button"
              className="review-btn"
              onClick={() => {
                props.setShow(false);
                props.setShowUnrecognised(true);
              }}
            >
              VIEW
              <FontAwesomeIcon icon={faArrowRight} className="ml-1" size="xs" />
            </button>
          </div>
        ) : null}
        {props.counts.unsupported.count ? (
          <div>
            <div className="count invalid">
              {props.counts.unsupported.count}
              {props.counts.unsupported.synced_count ? (
                <div className="synced-count">
                  <span>+ {props.counts.unsupported.synced_count}</span>
                  <span>NEW</span>
                </div>
              ) : null}
            </div>
            <div className="info">
              Unsupported <br /> Symbols
            </div>
            <button
              type="button"
              className="review-btn"
              onClick={() => {
                props.setShow(false);
                props.setShowUnsupported(true);
              }}
            >
              VIEW
              <FontAwesomeIcon icon={faArrowRight} className="ml-1" size="xs" />
            </button>
          </div>
        ) : null}
        {props.counts.tplusone.count ? (
          <div>
            <div className="count invalid">
              {props.counts.tplusone.count}
              {props.counts.tplusone.synced_count ? (
                <div className="synced-count">
                  <span>+ {props.counts?.tplusone?.synced_count}</span>
                  <span>NEW</span>
                </div>
              ) : null}
            </div>
            <div className="info">
              T+1 <br /> Symbols
            </div>
            <button
              type="button"
              className="review-btn"
              onClick={() => {
                props.setShow(false);
                props.setShowTplusone(true);
              }}
            >
              VIEW
              <FontAwesomeIcon icon={faArrowRight} className="ml-1" size="xs" />
            </button>
          </div>
        ) : null}
      </section>
    </div>
  );
};

export default ImportSummary;
